<template>
    <div class="searchBrand" >
        <div class="brand-item" v-for="(item,index) in washProductBrandList" :key="index" @click="onBrand(item)">
            {{ item.brandName }}
        </div>
    </div>
</template>

<script>
import { get, postJson, post } from '@/utils/request.js';

export default {
    data(){
        return{
            washProductBrandList: [],
        }
    },
    mounted() {
        this.getWashProductBrandList();
    },
    methods:{
        getWashProductBrandList(){
            get("/wash/utils/findAllWashProductBrand").then((res)=>{
                if(res.success){
                    this.washProductBrandList = res.list
                }
            })
        },

        onBrand(brandItem){
            this.$emit("onBrand", brandItem)
        }
    }
}
</script>

<style scoped lang="scss">
.searchBrand{
    width: 100%;
    height: 100%;
    overflow-y: scroll;

    .brand-item{
        display: inline-block;
        margin:  0 0 10px 10px;
        padding: 12px 20px;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        cursor: pointer;
    }

}
</style>